
const skills = [
    {   id:1,
        skillEnd:'Front-end Skills',
        skills:[
            {id:'1', skill:'HTML', percentage:"92%"},
            {id:'2',skill:'CSS3', percentage:"82%"},
            {id:'3',skill:'JS + ES6', percentage:"78%"},
            {id:'4',skill:'BOOTSTRAP', percentage:"88%"},
            {id:'5',skill:'REACT', percentage:"80%"},
            {id:'6',skill:'SASS', percentage:"30%"},
            {id:'7',skill:'TAILWIND', percentage:"60%"},
            {id:'8',skill:'D3.JS', percentage:"25%"},
            {id:'9',skill:'JQUERY', percentage:"73%"},
    
        ]
    },
    {   id:2,
        skillEnd:'Back-end Skills',
        skills:[
            {id:'10', skill:'ExpressJS', percentage:"92%"},
            {id:'11',skill:'NodeJS', percentage:"82%"},
            {id:'13',skill:'PHP', percentage:"88%"},
            {id:'14',skill:'C', percentage:"80%"},
            {id:'15',skill:'C++', percentage:"30%"},
            {id:'16',skill:'TESTING (Mocha + Chai)', percentage:"60%"},
            {id:'17',skill:'DATABASE (Postgres, Mysql, MongoDB)', percentage:"25%"},
            {id:'18',skill:'DOCUMENTATION (Swagger)', percentage:"73%"},
            {id:'18',skill:'SEQUELIZE  ', percentage:"73%"},
        ]
    }
]

export default skills;